var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFilterCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6357 6.36429C20.15 5.87857 19.4214 5.87857 18.9357 6.36429L9.82857 15.4714L6.06429 11.7071C5.57857 11.2214 4.85 11.2214 4.36429 11.7071C3.87857 12.1929 3.87857 12.9214 4.36429 13.4071L8.97857 18.0214C9.22143 18.2643 9.46429 18.3857 9.82857 18.3857C10.1929 18.3857 10.4357 18.2643 10.6786 18.0214L20.6357 8.06429C21.1214 7.57857 21.1214 6.85 20.6357 6.36429Z",
    fill: "#7B35D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFilterCheck);
export default __webpack_public_path__ + "static/media/icn_filterCheck.f9c143eb67337e8f5486dc9ff5695952.svg";
export { ForwardRef as ReactComponent };